import type { OgMeta } from "./metadata";

/** Page components own title/description; the route owns canonical and share/index metadata. */
export function syncRouteMetadata(meta: OgMeta) {
	let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
	if (!canonical) {
		canonical = document.createElement("link");
		canonical.rel = "canonical";
		document.head.append(canonical);
	}
	canonical.href = meta.url;
	for (const node of document.querySelectorAll("[data-page-meta]")) node.remove();
	const values: Record<string, string | undefined> = {
		"og:type": meta.type, "og:title": meta.title, "og:description": meta.description,
		"og:image": meta.image, "og:url": meta.url, "og:locale": meta.locale,
		"twitter:title": meta.title, "twitter:description": meta.description, "twitter:image": meta.image,
		robots: meta.noindex ? "noindex" : undefined, keywords: meta.keywords?.join(", "),
	};
	for (const [key, value] of Object.entries(values)) {
		if (!value) continue;
		const attr = key.startsWith("og:") ? "property" : "name";
		let node = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
		if (!node) {
			node = document.createElement("meta");
			node.setAttribute(attr, key);
			node.setAttribute("data-page-meta", "");
			document.head.append(node);
		}
		node.content = value;
	}
	for (const data of meta.jsonLd ?? []) {
		const script = document.createElement("script");
		script.type = "application/ld+json";
		script.setAttribute("data-page-meta", "");
		script.textContent = JSON.stringify(data);
		document.head.append(script);
	}
}
